<script>
import CommonTableComponent from "@/components/table.vue";
import pagination from "@/mixins/pagination";
import tableSearch from "@/mixins/tableSearch";
import apiEndpoints from "@/services/apiEndpoints";
import user from "@/mixins/user";
import { mapState } from "vuex";

export default {
  name: "WorkOrdersApproveRequire",
  mixins: [pagination, tableSearch, user],
  components: {
    CommonTableComponent,
  },
  data() {
    return {
      filters: {
        page: 1,
        column: this.$route.query.column || "submit_date",
        dir: this.$route.query.dir || "DESC"
      },
      busyGetData: false,
      workOrders: [],
      isExpanded: false,
    };
  },
  created() {
    this.getData()
  },
  methods: {
    async getData() {
      this.busyGetData = true;
      if (!this.canUserDelete()) {
        // ホーム管理権限があるユーザー以外はリクエストパラメータに id 指定で自身が承認者の作業指示のみを取得
        this.filters.user_id = this.currentUser.id
      }
      const response = await this.$http.get(apiEndpoints.requested_approve_work_order(), {
        ...this.filters,
      });
      const {status, data} = response;
      this.busyGetData = false;
      if (status) {
        const result = data.result;
        this.workOrders = this.$_.isEmpty(result.data) ? [] : result.data;
        const meta = this.$_.isEmpty(result.meta) ? [] : result.meta;
        this.setMeta(meta);
        this.$emit('view-work-order-message',this.hasRemand());
      }
    },
    hasRemand(){
        // 差戻があるかどうか
        if(this.workOrders.filter((item)=>item.workflow_status == "差戻").length > 0){
          return true;
        }
        return false;
    },
    updateUrlFilters() {
      this.getData()
    },
    toggleItem() {
      this.isExpanded = !this.isExpanded;
    },
    workOrderName(history) {
      return history?.workflow_temporary_by_work_order?.json?.name;
    },
    getRouteParams(history) {
      return {
        id: history.case_id,
        work_order_id: history.id,
      };
    },
    getRouteQuery(history) {
      return {
        tmp: 1,
        //work_order_id: history.work_order_id
      };
    },
    validHistory(history) {
      return !! history.workflow_temporary_by_work_order;
    },
  },
  watch: {
    'filters.page': {
      immediate: false,
      handler() {
        this.getData();
      },
    },
  },
  computed: {
    headers() {
      return [
        {
          text: "承認依頼日",
          value: "submit_date",
          sortable: true,
        },
        {
          text: "作成者",
          value: "create_user_name",
          sortable: true,
        },
        {
          text: "申請者",
          value: "submit_user_name",
          sortable: true,
        },
        {
          text: "承認者",
          value: "process_user_name",
          sortable: true,
        },
       {
          text: "処理",
          value: "workflow_status",
          sortable: true,
        },
        {
          text: "作業指示名",
          value: "work_order_name",
          sortable: true,
          width: 50,
        },
      ];
    },
    ...mapState({
      currentUser: state => state.auth.user,
    })
  },
};
</script>

<template>
  <div class="row">
    <b-overlay
      :show="busyGetData"
      rounded
      opacity="0.6"
      spinner-small
      spinner-variant="primary"
      class="d-inline-block"
    >
      <div class="col-lg-12">
        <div class="card">
          <div class="card-body">
            <div
              @click="toggleItem()"
              v-b-toggle.collapse-notification-workOrders
              class="card-title mb-2 mt-2"
            >
              <span class="font-size-16">作業指示承認待ち（{{ meta.total }}件）</span>
              <span :class="{'rotate': isExpanded}" class="icon">▼</span>
            </div>
            <b-collapse id="collapse-notification-workOrders">
              <CommonTableComponent :scrollAble="workOrders.length >= this.$constant.scroll_able_records">
                <thead class="table-light">
                <tr>
                  <th
                    :style="`width: ${item.width}`"
                    v-for="(item, index) in headers"
                    :key="index"
                    :class="getHeaderClass(item)"
                  >
                    <span v-if="item.sortable" @click="clickSort(item.value)">
                      {{ item.text }}
                      <i :class="getSortClass(item.value)"></i>
                    </span>
                    <span v-else>
                      {{ item.text }}
                    </span>
                  </th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="(item, index) in workOrders" :key="index">
                  <td>
                    {{ item.submit_date }}
                  </td>
                  <td>
                    {{ item.create_user_name }}
                  </td>
                  <td>
                    {{ item.submit_user_name }}
                  </td>
                  <td>
                    {{ item.process_user_name }}
                  </td>
                  <td>
                    {{ item.workflow_status }}
                  </td>

                  <td class="text-decoration-underline">
                    <router-link
                      :to="{
                        name: 'projects.sales.instructions.detail',
                        params: getRouteParams(item),
                        query: getRouteQuery(item)
                      }"
                    >
                      {{ item.work_order_name }}
                    </router-link>
                  </td>
                </tr>
                <tr v-if="!workOrders.length && !busyGetData">
                  <td colspan="7" class="text-center">
                    承認待ちの作業指示はありません。
                  </td>
                </tr>
                </tbody>
              </CommonTableComponent>
            </b-collapse>
          </div>
        </div>
      </div>
    </b-overlay>
  </div>
  <!-- end row -->
</template>
<style scoped>
.icon {
  float: right;
  transition: transform 0.3s;
}

.rotate {
  transform: rotate(-90deg);
}
</style>
